import React, { useState } from 'react';

export default (WrappedComponent) => (props) =>{
  const [searchValue, onSearch] = useState('');
  return <WrappedComponent {...props} searchValue={searchValue} onSearch={onSearch}/>;
};

